import * as basicLightbox from 'basiclightbox'
import ReadMore from './ReadMore';

export default class CustomLightbox{
	constructor(element){
		this.element = element;

		if(typeof this.element.dataset.customlightbox === 'undefined'){
			throw new Error('[Customlightbox.js] No data-customlightbox data attribute');
		}

		if(typeof this.element.dataset.youtubeId === 'undefined'){
			throw new Error('[Customlightbox.js] No youtube ID supplied');
		}

		// if(typeof this.element.dataset.lightboxExcerpt === 'undefined') {
		// 	throw new Error('[Customlightbox.js] No excerpt set');
		// }

		// if(typeof this.element.dataset.singleVideoLink === 'undefined') {
		// 	throw new Error('[Customlightbox.js] No permalink set');
		// }

		// if(typeof this.element.dataset.lightboxFullText === 'undefined') {
		// 	throw new Error('[Customlightbox.js] Full text has not been set')
		// }
		// if(typeof this.element.dataset.type === 'undefined'){
		// 	throw new Error('[Customlightbox.js] No data-type data attribute');
		// }

		if(document.querySelector('.youtube-button') !== null){
			this.youtubeLink = document.querySelector('.youtube-button').cloneNode(true);
		}
		if(document.querySelector('.spotify-follow') !== null){
			this.spotifyLink = document.querySelector('.spotify-follow').cloneNode(true);
		}
		console.log(document.querySelector('.apple-follow'));
		if(document.querySelector('.apple-follow') !== null){
			this.appleLink = document.querySelector('.apple-follow').cloneNode(true);
		}

		this.createModal();

		this.element.addEventListener('click', ev => {
			ev.preventDefault();
			const el = this.instance.element(),
				youtubeEl = el.querySelector('.youtube-button');

			if(typeof gapi !== 'undefined' && youtubeEl !== null){
				if(typeof youtubeEl.dataset.channelid !== 'undefined'){
					gapi.ytsubscribe.render(youtubeEl, {
						'channelid': youtubeEl.dataset.channelid,
						'layout': 'default'
					});
				}
			}

			this.instance.show();
			let readmore = new ReadMore(document.querySelector('.basicLightbox .readmore'));
		});
	}

	createModal(){
		let template = document.createElement('div');
		template.classList.add('container');

		if(this.element.dataset.customlightbox.length){
			let content = `<h2>${this.element.dataset.customlightbox}</h2>`
			if(this.element.dataset.lightboxExcerpt) {
				content += `<p data-excerpt="${this.element.dataset.lightboxExcerpt ?? ''}" data-full-text="${this.element.dataset.lightboxFullText ?? ''}"><span class="readmore-text">${this.element.dataset.lightboxExcerpt}</span>`;

				if(this.element.dataset.singleVideoLink) {
					content += `<button class="readmore">Read More</button>`;
				}

				content += `</p>`;
			}
			template.insertAdjacentHTML('afterbegin', content);
		}

		if(this.element.dataset.youtubeId){
			template.insertAdjacentHTML('beforeend', `
				<div class="wp-block-embed__wrapper">
					<iframe src="https://www.youtube.com/embed/${this.element.dataset.youtubeId}" allowfullscreen="" frameborder="0"></iframe>
				</div>
			`);
		}

		if(this.element.href){
			let youtube = this.youtubeLink ? this.youtubeLink.outerHTML :  '',
			    spotify = this.spotifyLink ? this.spotifyLink.outerHTML :  '',
			    apple = this.appleLink ? this.appleLink.outerHTML :  '';

			template.insertAdjacentHTML('beforeend', `
				<div class="read-more">
					${youtube}
					${spotify}
					${apple}
				</div>
			`);
		}

		this.instance = basicLightbox.create(template.outerHTML,{
			onShow : (instance) => {
				document.documentElement.classList.add('modal-open');
			},
			onClose : (instance) => {
				document.documentElement.classList.remove('modal-open');
			},
		});
	}
}